import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";
import Banner from "../Sections/about/Banner";
import Breadcrumb from "../Sections/about/Breadcrumb";
import Logos from "../Sections/about/Logos";
import Selection from "../Sections/about/Selection";
import Team from "../Sections/about/Team";
import Testimonial from "../Sections/about/Testimonial";

function AboutUs() {
    const { data: {about} } = useGetSettingQuery()

    return ( 
        <>
            {about.topbar && <Breadcrumb/>}
            {about.selection && <Selection/>}
            {about.banner && <Banner/>}
            {about.team && <Team/>}
            {about.testimonial && <Testimonial/>}
            {about.logos && <Logos/>}
        </>
    );
}

export default AboutUs;